import React, { Component } from 'react'
import { graphql, navigate } from 'gatsby'
import parse from 'html-react-parser'

import Seo from '../components/seo'
import { RightArrow } from '../components/icons'
import renderBlock from '../utils/render-block'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Link from '../utils/link'
import sal from 'sal.js'

class ProjectTemplate extends Component {

  constructor(props) {
    super(props);

    this.state = {
      active: false,
      scrolled: false,
      bottom: false,
      animateIn: false,
      shuffledFeatured: [], // Initialize with an empty array
    };

    this.scrollDetect = this.scrollDetect.bind(this);
    this.toggleInfo = this.toggleInfo.bind(this);
  }

  componentDidMount() {
    const { wpProject, allWpProject } = this.props.data;
    window._toggleInfo = this.toggleInfo;
    if (wpProject && wpProject.acf && wpProject.acf.digitalOnly && wpProject.acf.contentBlocks?.length === 0) {
      this.toggleInfo();
    }
    window.addEventListener('scroll', this.scrollDetect);
    this.animationTimeout = setTimeout(() => {
      this.setState({ animateIn: true });
    }, 1000);

    // filter projects by !digitalOnly and same sector
    let related = allWpProject?.nodes?.filter(el => 
      !el.acf?.noBio &&
      el.uri !== this.props.data.wpProject.uri &&
      el.sectors?.nodes?.[0]?.slug === this.props.data?.wpProject?.sectors?.nodes?.[0]?.slug
    )

    // if related doesn't === 4 in length fill it with any allWpProject apart from the current uri
    if (related.length === 0) {
      related = allWpProject?.nodes?.filter(el => 
        !el.acf?.noBio &&
        el.uri !== this.props.data.wpProject.uri
      )
    }

    // randomize order
    related = related.sort(() => Math.random() - 0.5);
    // Update state with shuffled array
    this.setState({ shuffledFeatured: related }, () => {
      // Reinitialize sal.js after DOM updates
      sal();
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollDetect);
    clearTimeout(this.animationTimeout);
  }

  onScroll = (e) => {
    let { scrolled, opacity, bottom } = this.state

    const curScroll = window.scrollY || document.scrollTop
    scrolled = curScroll > 1

    const vh = window.innerHeight - 76
    const bottomOfPage = curScroll + (window.innerHeight * 2) >= document.documentElement.scrollHeight;

    opacity = false
    if (bottomOfPage) {
      bottom = true;
    } else {
      bottom = false;
    }

    if (curScroll > vh) opacity = true

    requestAnimationFrame(() => {
      this.setState({ scrolled, opacity, bottom })
    })
  }

  scrollDetect = () => {
    window.clearTimeout( this.isScrolling )
    this.isScrolling = setTimeout(this.onScroll, 0);
  }

  renderBanner() {
    const { wpProject } = this.props.data

    return (
      <section className='project-template__banner'>
        <div className='project-template__inner'>
          { wpProject.acf.subtitle && <h2 className='project-template__subtitle'>{parse(wpProject.acf.subtitle)}</h2> }
        </div>
        { wpProject.acf.banner?.video &&
          <video src={wpProject.acf.banner.video} autoPlay muted loop playsInline />
        }
        { !wpProject.acf.banner?.video &&
          <>
            <GatsbyImage 
              className='project-template__banner__desktop'
              image={getImage(wpProject.acf.banner?.desktop?.image?.localFile)} 
              alt={wpProject.acf.banner?.desktop?.image?.altText}
            />
            <GatsbyImage 
              className='project-template__banner__mobile'
              image={getImage(wpProject.acf.banner?.mobile?.image?.localFile)} 
              alt={wpProject.acf.banner?.mobile?.image?.altText} 
            />
          </>
        }
      </section>
    )
  }
  renderPagination() {
    const { shuffledFeatured } = this.state

    return (
      <section className="four-items four-items--project-template">
        <div className="four-items__inner">
          <hr />
          { shuffledFeatured?.length && shuffledFeatured.slice(0, 4).map((el, i) => {
            let image = el.acf?.thumbnail?.landscapeImage?.localFile
            if ((i + 1) % 2 === 0) image = el.acf?.thumbnail?.portraitImage?.localFile
            return (
              <Link key={i} to={el.uri} className='four-items__item' data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease'>
                { el.acf.thumbnail?.video &&
                  <div className={`featured-projects__video-thumb featured-projects__video-thumb--${el.acf.thumbnail.videoSize}`}>
                    <video src={el.acf.thumbnail.video} autoPlay muted loop playsInline />
                  </div>
                }
                { !el.acf.thumbnail.video && image?.extension !== 'gif' && <GatsbyImage image={getImage(image)} alt={el.acf?.thumbnail?.landscapeImage?.altText} /> }
                { !el.acf.thumbnail.video && image?.extension === 'gif' && <img className='gif' src={image.publicURL} alt={el.acf?.thumbnail?.landscapeImage?.altText} /> }
                { !el.acf.thumbnail.video && !image && el.acf.webGrid &&
                  <div className={`featured-projects__video-thumb featured-projects__video-thumb--${el.acf.thumbnail.videoSize}`}>
                    <video src={el.acf.webGrid} autoPlay muted loop playsInline />
                  </div>
                }
                <div className='four-items__cap'>
                  { el.title && <h4>{parse(el.title)}</h4> }
                </div>
              </Link>
            )
          })}
        </div>
      </section>
    )
  }

  toggleInfo(force = false) {
    let { active } = this.state
    if (active || force) {
      document && document.querySelector('body').classList.remove('info-active')
      this.setState({ active: false })
    } else {
      document && document.querySelector('body').classList.add('info-active')
      this.setState({ active: true })
    }
  }

  renderInfo() {
    const { wpProject } = this.props.data
    let { active, scrolled, bottom, animateIn } = this.state

    const projectInfoTitle = wpProject.acf.projectInfo.title ? wpProject.acf.projectInfo.title : wpProject.acf.subtitle

    const buttonProps = {
      type: 'button',
      onMouseEnter: () => window?._handleMouseEnter(''),
      onMouseLeave: () => window?._handleMouseLeave(),
    }

    return (
      <section className={`project-info${active ? ' active' : '' }${animateIn ? ' scrolled' : '' }${bottom ? ' bottom' : '' }${scrolled ? ' is-scrolled' : '' }`}>
        <button className="project-info__menu" onClick={() => wpProject.acf.digitalOnly && wpProject.acf.contentBlocks?.length === 0 ? window.history.back(-1) : this.toggleInfo()} {...buttonProps}>
          { wpProject.title && <h1>{parse(wpProject.title)}</h1> }
          { (!wpProject.acf.digitalOnly || wpProject.acf.contentBlocks?.length > 0) &&
            <>
              <button className='project-info__toggle project-info__toggle--mobile'>Info <span className='plus'></span></button>
              <button className='project-info__toggle project-info__toggle--desktop'>Project Info <span className='plus'></span></button>
            </>
          }
          { wpProject.acf.digitalOnly && wpProject.acf.contentBlocks?.length === 0 &&
            <>
              <button className='project-info__toggle'>Close</button>
              <button className='project-info__hamburger project-info__hamburger--active'>
                <span className="lines"></span>
              </button>
            </>
          }
          <hr />
        </button>
        <div className={`project-info__content ${active ? ' active' : '' }`}>
          <div className="project-info__inner">
            <button className='project-info__toggle-screen' onClick={() => !wpProject.acf.digitalOnly && wpProject.acf.contentBlocks?.length > 0 ? this.toggleInfo() : window.history.back(-1)} />
            <div className='project-info__inner-content'>
              { projectInfoTitle && <h2>{parse(projectInfoTitle)}</h2> }
              <div className='project-info__wrapper'>
                <div className="project-info__intro">
                  <h4>Overview</h4>
                  { wpProject.acf.projectInfo?.content && <div>{parse(wpProject.acf.projectInfo.content)}</div> }
                </div>
                <div className='project-info__lists'>
                  { wpProject.disciplines?.nodes?.length > 0 && 
                    <ul className='project-info__scope'>
                      <li><strong>Scope</strong></li>
                      { wpProject.acf.projectInfo.scope && <li>{parse(wpProject.acf.projectInfo.scope)}</li> }
                      { !wpProject.acf.projectInfo.scope && wpProject.disciplines.nodes.map((el, i) => (
                        <li key={i}><Link to={`/discipline/${el.slug}`}>{el.name && parse(el.name)}</Link></li>
                      )) }
                    </ul>
                  }
                  { wpProject.acf.projectInfo?.collaborators?.length > 0 && 
                    <ul>
                      <li><strong>Collaborators</strong></li>
                      { wpProject.acf.projectInfo.collaborators.map((el, i) => (
                        <li key={i}>{el.name && parse(el.name)}</li>
                      )) }
                    </ul>
                  }
                  <div>
                    { wpProject.acf.projectInfo.website && <Link className='button' to={wpProject.acf.projectInfo.website}><span>{wpProject.acf.projectInfo.website.replace(/^https?:\/\//, '').replace(/\/$/, '')}</span> <RightArrow /></Link>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  render() {
    const { wpProject } = this.props.data
    const containsDigital = wpProject.acf.contentBlocks?.find(el => el.fieldGroupName === 'project_Acf_ContentBlocks_Digital')

    return (
      <>
        <Seo bodyClass={`project-template${wpProject.acf.digitalOnly && wpProject.acf.contentBlocks?.length === 0 ? ' project-template--digital info-active' : ''}`} {...wpProject.seo} />
        { this.renderBanner() }
        { !containsDigital && this.renderInfo() }
        { wpProject?.acf?.contentBlocks?.map((el, i) => renderBlock(el, i, 'project'))  }
        { this.renderPagination() }
      </>
    )
  }
}

export const projectQuery = graphql`
  query ($id: String!) {
    allWpProject {
      nodes {
        ...ProjectCard  
      }
    }
    wpProject(id: {eq: $id}) {
      title
      uri
      seo {
        ...WpSeo
      }
      disciplines {
        nodes {
          slug
          name
        }
      }
      sectors {
        nodes {
          slug
          name
        }
      }
      acf {
        subtitle
        digitalOnly
        projectInfo {
          title
          content
          collaborators {
            name
          }
          website
          scope
        }
        banner {
          desktop {
            image {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 2000)
                }
              }
            }
          }
          mobile {
            image {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 900)
                }
              }
            }
          }
          video
          videoSize
        }
        contentBlocks {
          ... on WpProject_Acf_ContentBlocks_DoubleImage {
            fieldGroupName
            leftImage {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1200)
                }
                publicURL
              }
            }
            leftVideo
            leftImageCaption
            rightImage {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1200)
                }
                publicURL
              }
            }
            rightVideo
            rightImageCaption
          }
          ... on WpProject_Acf_ContentBlocks_Image {
            fieldGroupName
            image {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1600)
                }
                publicURL
              }
            }
            video
            mobileVideo
            mobileImage {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1000)
                }
              }
            }
            alignment
          }
          ... on WpProject_Acf_ContentBlocks_Digital {
            fieldGroupName
            image {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1600)
                }
                publicURL
              }
            }
            video
            title
            client
            sector
            technology
            services
            free {
              title
              content
            }
            weblink
          }
          ... on WpProject_Acf_ContentBlocks_MobileMockup {
            fieldGroupName
            leftImage {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1000)
                }
              }
            }
            middleImage {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1000)
                }
              }
            }
            rightImage {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1000)
                }
              }
            }
          }
          ... on WpProject_Acf_ContentBlocks_TitleContent {
            alignment
            content
            fieldGroupName
            title
          }
          ... on WpProject_Acf_ContentBlocks_WebMockup {
            fieldGroupName
            website {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1500)
                }
              }
            }
          }
          ... on WpProject_Acf_ContentBlocks_Gallery {
            fieldGroupName
            gallery {
              altText
              caption
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1500)
                }
              }
            }
          }
          ... on WpProject_Acf_ContentBlocks_Video {
            alignment
            caption
            video
            coverImage {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            fieldGroupName
          }
          ... on WpProject_Acf_ContentBlocks_Quote {
            fieldGroupName
            name
            quote
            alignment
          }
        }
      }
    }
  }
`

export default ProjectTemplate
